import Tabs from './Tabs';
import PageHeader from './PageHeader';
import ChatInvites from './ChatInvites';
import SendRequests from './SendRequests';
import SentRequests from './SentRequests';
import ChatStyles from '../Chat.module.css';
import AppLayout from '../../../components/AppLayout';
import ErrorToast from '../../../components/Toast/ErrorToast';
import SuccessToast from '../../../components/Toast/SuccessToast';
import useChatRequestsFunctions from './useChatRequestsFunctions';
import { useTranslation } from 'react-i18next';

const ChatRequests = ({ socket }) => {
  const { t } = useTranslation();
  const {
    chatUserLoading,
    chatUsers,
    chatUserSearch,
    setChatUserSearch,
    pendingCircularLoader,
    notAvailableCircularLoader,
    notAcceptedCircularLoader,
    showErrorToast,
    setShowErrorToast,
    showSuccessToast,
    setShowSuccessToast,
    toastMessage,
    pendingChatUserLoading,
    pendingChatUsers,
    pendingChatSearch,
    setPendingChatSearch,
    prevSentRequestLoading,
    prevSentRequests,
    prevSentSearch,
    setPrevSentSearch,
    cardListRef1,
    cardListRef2,
    cardListRef3,
    handleSendReqest,
    handleAcceptRequest,
    handleAcceptGroupRequest,
    handleCancelGroupRequest,
    handleRemoveRequest,
    handleCancelRequest,
    pendingSearch,
    notAvailableusersSearch,
    notAcceptedUsersSearch,
    userLogin,
  } = useChatRequestsFunctions(socket);

  return (
    <AppLayout>
      <div className={ChatStyles.content}>
        {/* LEFT PANEL */}
        <div className={ChatStyles.chatLists}>
          {/* Panel header */}
          <PageHeader />

          {/* Tabs */}
          <Tabs />

          {/* Scrollable sections */}
          <div className={ChatStyles.chatLists_users1}>
            {/* ── Chat Invites ── */}
            <ChatInvites
              pendingChatSearch={pendingChatSearch}
              setPendingChatSearch={setPendingChatSearch}
              pendingSearch={pendingSearch}
              cardListRef1={cardListRef1}
              pendingChatUserLoading={pendingChatUserLoading}
              pendingChatUsers={pendingChatUsers}
              handleAcceptGroupRequest={handleAcceptGroupRequest}
              handleAcceptRequest={handleAcceptRequest}
              handleCancelGroupRequest={handleCancelGroupRequest}
              handleCancelRequest={handleCancelRequest}
              pendingCircularLoader={pendingCircularLoader}
            />

            {/* ── Send Requests + Sent Requests (admin/fileAdmin only) ── */}
            {(!userLogin?.userInfo?.data?.user?.modules?.adminOnlyChat ||
              userLogin?.userInfo?.data?.user?.role === 'clientAdmin' ||
              userLogin?.userInfo?.data?.user?.role === 'fileAdmin') && (
              <>
                {/* Send Requests */}
                <SendRequests
                  chatUserSearch={chatUserSearch}
                  setChatUserSearch={setChatUserSearch}
                  notAvailableusersSearch={notAvailableusersSearch}
                  chatUserLoading={chatUserLoading}
                  cardListRef2={cardListRef2}
                  chatUsers={chatUsers}
                  handleSendReqest={handleSendReqest}
                  notAvailableCircularLoader={notAvailableCircularLoader}
                />

                {/* Sent Requests */}
                <SentRequests
                  cardListRef3={cardListRef3}
                  prevSentSearch={prevSentSearch}
                  setPrevSentSearch={setPrevSentSearch}
                  notAcceptedUsersSearch={notAcceptedUsersSearch}
                  prevSentRequestLoading={prevSentRequestLoading}
                  prevSentRequests={prevSentRequests}
                  handleRemoveRequest={handleRemoveRequest}
                  notAcceptedCircularLoader={notAcceptedCircularLoader}
                />
              </>
            )}
          </div>
        </div>

        {/* RIGHT PLACEHOLDER */}
        <div className={ChatStyles.chat_placeholder}>
          <svg width='48' height='48' viewBox='0 0 24 24' fill='none' stroke='#cbd5e1' strokeWidth='1.5'>
            <path d='M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2' />
            <circle cx='9' cy='7' r='4' />
            <path d='M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75' />
          </svg>
          <p className={ChatStyles.chat_placeholder_heading}>{t('screens.chat.managePageTitle')}</p>
          <p className={ChatStyles.chat_placeholder_subHeading}>{t('screens.chat.managePageSub')}</p>
        </div>

        <ErrorToast message={toastMessage} showToast={showErrorToast} onClose={() => setShowErrorToast(false)} duration={3500} />
        <SuccessToast message={toastMessage} showToast={showSuccessToast} onClose={() => setShowSuccessToast(false)} duration={3500} />
      </div>
    </AppLayout>
  );
};

export default ChatRequests;
